import React from "react";
import PropTypes from "prop-types";

import styles from "./BackgroundImage.css";

const BackgroundImage = ({ children, src, style = {} }) => (
  <div className={styles.root}>
    <div className={styles.image} style={{ backgroundImage: `url(${src})`, ...style }}>
      {children}
    </div>
  </div>
);

BackgroundImage.propTypes = {
  children: PropTypes.node,
  src: PropTypes.string.isRequired,
  style: PropTypes.object, // eslint-disable-line
};

export default BackgroundImage;
